/**
 * 社交管理按钮权限配置
 */
export default {
  // 同城城市管理
  sameCityManage: {
    // 编辑
    edit: "socialManage_sameCityManage_edit"
  }
}